import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'tr-question-wrapper',
  templateUrl: './question-wrapper.component.html',
  // styleUrls: ['./question-wrapper.component.scss']
})
export class QuestionWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', {read: ViewContainerRef}) fieldComponent: ViewContainerRef;
}



// WEBPACK FOOTER //
// ./src/app/stage/components/question-wrapper/question-wrapper.component.ts